import React from 'react'

export default function BluesearchIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.16664 9.33328C7.46781 9.33328 9.33328 7.46781 9.33328 5.16664C9.33328 2.86547 7.46781 1 5.16664 1C2.86547 1 1 2.86547 1 5.16664C1 7.46781 2.86547 9.33328 5.16664 9.33328Z" stroke="#111AE9" stroke-width="1.05483" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M10.9992 11.0002L8.11035 8.11133" stroke="#111AE9" stroke-width="1.05483" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    )
}
